export interface ItemNameWithQuantityProps {
  name: string;
  quantity: number;
}

export const ItemNameWithQuantity = ({
  name,
  quantity,
}: ItemNameWithQuantityProps) => {
  return (
    <p className="text-lg text-[#373737] max-w-[310px] text-left">
      {name} {quantity > 1 && `× ` + quantity}
    </p>
  );
};
